<template>
  <v-main>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex sx12>
          <h1  class="mt-n2 mb-4">{{ ct.TitleText }}</h1>
          <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
          <v-card v-else raised>
            <v-card-text >
              <v-form ref="form" v-model="valid">
                <v-layout justify-end>
                  <div><v-checkbox :label="ct.Active" v-model="form.active" :color="'primary'"></v-checkbox></div>
                </v-layout>
                <v-text-field v-if="id" disabled v-model="id" :label="ct.Id"></v-text-field>
                <v-text-field v-model="form.name" :label="ct.Name" :rules="[rules.required]"></v-text-field>
                <v-text-field v-model="form.fullName" :label="ct.Full_name" :rules="[rules.required]"></v-text-field>
                <v-text-field v-model="form.licensedUsers" :label="$t('User licenses')" type="number" :rules="[rules.required]"></v-text-field>
                <!--v-text-field disabled v-model="form.claims" :label="$t('Allowed modules (claims)')"></v-text-field-->
                <ImageUpload :imageFile=logoImage :btnName="$t('Change logo')" :toolTip="$t('Recommended logo size:') +' 350 x 100'"  @imageChange="changeLogo"></ImageUpload>
                <h2 class="mt-4">{{$t("Allowed modules (claims)")}}</h2>
                <v-container fluid>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-switch v-model="hasAdmin">
                        <div v-if="hasAdmin" slot="label"><span class="black--text">{{license.adminNo}} - {{license.adminName}} (SVS Only!)</span></div>
                        <div v-else slot="label">{{license.adminNo}} - {{license.adminName}} (SVS Only!)</div>
                      </v-switch>
                      <v-switch v-model="hasCorporateAdmin">
                        <div v-if="hasCorporateAdmin" slot="label"><span class="black--text">{{license.corporateAdminNo}} - {{license.corporateAdminName}}</span></div>
                        <div v-else slot="label">{{license.corporateAdminNo}} - {{license.corporateAdminName}}</div>
                      </v-switch>
                      <v-switch v-model="hasDeliveryInspection">
                        <div v-if="hasDeliveryInspection" slot="label"><span class="black--text">{{license.deliveryInspectionNo}} - {{license.deliveryInspectionName}}</span></div>
                        <div v-else slot="label">{{license.deliveryInspectionNo}} - {{license.deliveryInspectionName}}</div>
                      </v-switch>
                      <v-switch v-model="hasWheelLoader">
                        <div v-if="hasWheelLoader" slot="label"><span class="black--text">{{license.wheelLoaderNo}} - {{license.wheelLoaderName}}</span></div>
                        <div v-else slot="label">{{license.wheelLoaderNo}} - {{license.wheelLoaderName}}</div>
                      </v-switch>
                      <v-switch v-model="hasAsphaltDeliveryVehicle">
                        <div v-if="hasAsphaltDeliveryVehicle" slot="label"><span class="black--text">{{license.asphaltDeliveryVehicleNo}} - {{license.asphaltDeliveryVehicleName}}</span></div>
                        <div v-else slot="label">{{license.asphaltDeliveryVehicleNo}} - {{license.asphaltDeliveryVehicleName}}</div>
                      </v-switch>
                      <v-switch v-model="hasAsphaltDeliveryCarrier">
                        <div v-if="hasAsphaltDeliveryCarrier" slot="label"><span class="black--text">{{license.asphaltDeliveryCarrierNo}} - {{license.asphaltDeliveryCarrierName}}</span></div>
                        <div v-else slot="label">{{license.asphaltDeliveryCarrierNo}} - {{license.asphaltDeliveryCarrierName}}</div>
                      </v-switch>
                      <v-switch v-model="hasPreRegistration">
                        <div v-if="hasPreRegistration" slot="label"><span class="black--text">{{license.preRegistrationNo}} - {{license.preRegistrationName}}</span></div>
                        <div v-else slot="label">{{license.preRegistrationNo}} - {{license.preRegistrationName}}</div>
                      </v-switch>
                      <v-switch v-model="hasClassifier">
                        <div v-if="hasClassifier" slot="label"><span class="black--text">{{license.classifierNo}} - {{license.classifierName}}</span></div>
                        <div v-else slot="label">{{license.classifierNo}} - {{license.classifierName}}</div>
                      </v-switch>
                      <v-switch v-model="hasScanCode">
                        <div v-if="hasScanCode" slot="label"><span class="black--text">{{license.scanCodeNo}} - {{license.scanCodeName}}</span></div>
                        <div v-else slot="label">{{license.scanCodeNo}} - {{license.scanCodeName}}</div>
                      </v-switch>
                      <v-switch v-model="hasNomination">
                        <div v-if="hasNomination" slot="label"><span class="black--text">{{license.nominationNo}} - {{license.nominationName}}</span></div>
                        <div v-else slot="label">{{license.nominationNo}} - {{license.nominationName}}</div>
                      </v-switch>
                      <v-switch v-model="hasUnloadingFuel">
                        <div v-if="hasUnloadingFuel" slot="label"><span class="black--text">{{license.unloadingFuelNo}} - {{license.unloadingFuelName}}</span></div>
                        <div v-else slot="label">{{license.unloadingFuelNo}} - {{license.unloadingFuelName}}</div>
                      </v-switch>
                      <v-switch v-model="hasBatchRegistration">
                        <div v-if="hasBatchRegistration" slot="label"><span class="black--text">{{license.batchRegistrationNo}} - {{license.batchRegistrationName}}</span></div>
                        <div v-else slot="label">{{license.batchRegistrationNo}} - {{license.batchRegistrationName}}</div>
                      </v-switch>
                      <v-switch v-model="hasStorageMap">
                        <div v-if="hasStorageMap" slot="label"><span class="black--text">{{license.storageMapNo}} - {{license.storageMapName}}</span></div>
                        <div v-else slot="label">{{license.storageMapNo}} - {{license.storageMapName}}</div>
                      </v-switch>
                      <v-switch v-model="hasScanMobile">
                        <div v-if="hasScanMobile" slot="label"><span class="black--text">{{license.scanMobileNo}} - {{license.scanMobileName}}</span></div>
                        <div v-else slot="label">{{license.scanMobileNo}} - {{license.scanMobileName}}</div>
                      </v-switch>
                      <v-switch v-model="hasApiImportExport">
                        <div v-if="hasApiImportExport" slot="label"><span class="black--text">{{license.apiImportExportNo}} - {{license.apiImportExportName}}</span></div>
                        <div v-else slot="label">{{license.apiImportExportNo}} - {{license.apiImportExportName}}</div>
                      </v-switch>
                      <v-switch v-model="hasCreateVehicle">
                        <div v-if="hasCreateVehicle" slot="label"><span class="black--text">{{license.createVehiclesNo}} - {{license.createVehiclesName}}</span></div>
                        <div v-else slot="label">{{license.createVehiclesNo}} - {{license.createVehiclesName}}</div>
                      </v-switch>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :loading="submitting" min-width="97px" :disabled="!valid" @click="submit" color="success">{{ct.SaveBtnText}} {{buttonAppend}}</v-btn>
              <v-btn color="primary" @click="preventLeave = false; $router.go(-1)">{{$t("Cancel")}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>
<script>

import { app } from '@/main'
import * as Admin from '@/core/admin'
import ct from '@/core/mixins/common-translations'
import rules from '@/core/mixins/common-rules'
import preventLeave from '@/core/mixins/preventLeave'
import * as License from '@/core/license'
import ImageUpload from '@/core/components/ImageUpload'
import { CorporationDetail } from '@/core/corporationDetail'

export default {
  mixins: [ct, rules, preventLeave],
  data: () => ({
    dataType: 'corporation',
    loading: true,
    submitting: false,
    valid: true,
    redirectTo: 'corporations',
    id: 0,
    form: {
      name: '',
      fullName: '',
      active: true,
      licensedUsers: 0,
      claims: []
    },
    logoDetail: null,
    logoImage: null,
    apiKeyDetail: null
  }),
  components: {
    ImageUpload
  },
  computed: {
    license: function () {
      return License
    },
    hasAdmin: {
      get: function () {
        return this.form.claims.includes(License.adminNo)
      },
      set: function (newValue) {
        if (newValue && !this.form.claims.includes(License.adminNo)) {
          // Add
          this.form.claims.push(License.adminNo)
          this.form.claims.sort()
        } else if (!newValue && this.form.claims.includes(License.adminNo)) {
          // Remove
          this.form.claims = this.form.claims.filter(e => e !== License.adminNo)
        }
      }
    },
    hasCorporateAdmin: {
      get: function () {
        return this.form.claims.includes(License.corporateAdminNo)
      },
      set: function (newValue) {
        if (newValue && !this.form.claims.includes(License.corporateAdminNo)) {
          // Add
          this.form.claims.push(License.corporateAdminNo)
          this.form.claims.sort()
        } else if (!newValue && this.form.claims.includes(License.corporateAdminNo)) {
          // Remove
          this.form.claims = this.form.claims.filter(e => e !== License.corporateAdminNo)
        }
      }
    },
    hasDeliveryInspection: {
      get: function () {
        return this.form.claims.includes(License.deliveryInspectionNo)
      },
      set: function (newValue) {
        if (newValue && !this.form.claims.includes(License.deliveryInspectionNo)) {
          // Add
          this.form.claims.push(License.deliveryInspectionNo)
          this.form.claims.sort()
        } else if (!newValue && this.form.claims.includes(License.deliveryInspectionNo)) {
          // Remove
          this.form.claims = this.form.claims.filter(e => e !== License.deliveryInspectionNo)
        }
      }
    },
    hasWheelLoader: {
      get: function () {
        return this.form.claims.includes(License.wheelLoaderNo)
      },
      set: function (newValue) {
        if (newValue && !this.form.claims.includes(License.wheelLoaderNo)) {
          // Add
          this.form.claims.push(License.wheelLoaderNo)
          this.form.claims.sort()
        } else if (!newValue && this.form.claims.includes(License.wheelLoaderNo)) {
          // Remove
          this.form.claims = this.form.claims.filter(e => e !== License.wheelLoaderNo)
        }
      }
    },
    hasAsphaltDeliveryVehicle: {
      get: function () {
        return this.form.claims.includes(License.asphaltDeliveryVehicleNo)
      },
      set: function (newValue) {
        if (newValue && !this.form.claims.includes(License.asphaltDeliveryVehicleNo)) {
          // Add
          this.form.claims.push(License.asphaltDeliveryVehicleNo)
          this.form.claims.sort()
        } else if (!newValue && this.form.claims.includes(License.asphaltDeliveryVehicleNo)) {
          // Remove
          this.form.claims = this.form.claims.filter(e => e !== License.asphaltDeliveryVehicleNo)
        }
      }
    },
    hasAsphaltDeliveryCarrier: {
      get: function () {
        return this.form.claims.includes(License.asphaltDeliveryCarrierNo)
      },
      set: function (newValue) {
        if (newValue && !this.form.claims.includes(License.asphaltDeliveryCarrierNo)) {
          // Add
          this.form.claims.push(License.asphaltDeliveryCarrierNo)
          this.form.claims.sort()
        } else if (!newValue && this.form.claims.includes(License.asphaltDeliveryCarrierNo)) {
          // Remove
          this.form.claims = this.form.claims.filter(e => e !== License.asphaltDeliveryCarrierNo)
        }
      }
    },
    hasPreRegistration: {
      get: function () {
        return this.form.claims.includes(License.preRegistrationNo)
      },
      set: function (newValue) {
        if (newValue && !this.form.claims.includes(License.preRegistrationNo)) {
          // Add
          this.form.claims.push(License.preRegistrationNo)
          this.form.claims.sort()
        } else if (!newValue && this.form.claims.includes(License.preRegistrationNo)) {
          // Remove
          this.form.claims = this.form.claims.filter(e => e !== License.preRegistrationNo)
        }
      }
    },
    hasClassifier: {
      get: function () {
        return this.form.claims.includes(License.classifierNo)
      },
      set: function (newValue) {
        if (newValue && !this.form.claims.includes(License.classifierNo)) {
          // Add
          this.form.claims.push(License.classifierNo)
          this.form.claims.sort()
        } else if (!newValue && this.form.claims.includes(License.classifierNo)) {
          // Remove
          this.form.claims = this.form.claims.filter(e => e !== License.classifierNo)
        }
      }
    },
    hasScanCode: {
      get: function () {
        return this.form.claims.includes(License.scanCodeNo)
      },
      set: function (newValue) {
        if (newValue && !this.form.claims.includes(License.scanCodeNo)) {
          // Add
          this.form.claims.push(License.scanCodeNo)
          this.form.claims.sort()
        } else if (!newValue && this.form.claims.includes(License.scanCodeNo)) {
          // Remove
          this.form.claims = this.form.claims.filter(e => e !== License.scanCodeNo)
        }
      }
    },
    hasNomination: {
      get: function () {
        return this.form.claims.includes(License.nominationNo)
      },
      set: function (newValue) {
        if (newValue && !this.form.claims.includes(License.nominationNo)) {
          // Add
          this.form.claims.push(License.nominationNo)
          this.form.claims.sort()
        } else if (!newValue && this.form.claims.includes(License.nominationNo)) {
          // Remove
          this.form.claims = this.form.claims.filter(e => e !== License.nominationNo)
        }
      }
    },
    hasUnloadingFuel: {
      get: function () {
        return this.form.claims.includes(License.unloadingFuelNo)
      },
      set: function (newValue) {
        if (newValue && !this.form.claims.includes(License.unloadingFuelNo)) {
          // Add
          this.form.claims.push(License.unloadingFuelNo)
          this.form.claims.sort()
        } else if (!newValue && this.form.claims.includes(License.unloadingFuelNo)) {
          // Remove
          this.form.claims = this.form.claims.filter(e => e !== License.unloadingFuelNo)
        }
      }
    },
    hasBatchRegistration: {
      get: function () {
        return this.form.claims.includes(License.batchRegistrationNo)
      },
      set: function (newValue) {
        if (newValue && !this.form.claims.includes(License.batchRegistrationNo)) {
          // Add
          this.form.claims.push(License.batchRegistrationNo)
          this.form.claims.sort()
        } else if (!newValue && this.form.claims.includes(License.batchRegistrationNo)) {
          // Remove
          this.form.claims = this.form.claims.filter(e => e !== License.batchRegistrationNo)
        }
      }
    },
    hasScanMobile: {
      get: function () {
        return this.form.claims.includes(License.scanMobileNo)
      },
      set: function (newValue) {
        if (newValue && !this.form.claims.includes(License.scanMobileNo)) {
          // Add
          this.form.claims.push(License.scanMobileNo)
          this.form.claims.sort()
        } else if (!newValue && this.form.claims.includes(License.scanMobileNo)) {
          // Remove
          this.form.claims = this.form.claims.filter(e => e !== License.scanMobileNo)
        }
      }
    },
    hasStorageMap: {
      get: function () {
        return this.form.claims.includes(License.storageMapNo)
      },
      set: function (newValue) {
        if (newValue && !this.form.claims.includes(License.storageMapNo)) {
          // Add
          this.form.claims.push(License.storageMapNo)
          this.form.claims.sort()
        } else if (!newValue && this.form.claims.includes(License.storageMapNo)) {
          // Remove
          this.form.claims = this.form.claims.filter(e => e !== License.storageMapNo)
        }
      }
    },
    hasApiImportExport: {
      get: function () {
        return this.form.claims.includes(License.apiImportExportNo)
      },
      set: function (newValue) {
        if (newValue && !this.form.claims.includes(License.apiImportExportNo)) {
          // Add
          this.form.claims.push(License.apiImportExportNo)
          this.form.claims.sort()
        } else if (!newValue && this.form.claims.includes(License.apiImportExportNo)) {
          // Remove
          this.form.claims = this.form.claims.filter(e => e !== License.apiImportExportNo)
        }
      }
    },
    hasCreateVehicle: {
      get: function () {
        return this.form.claims.includes(License.createVehiclesNo)
      },
      set: function (newValue) {
        if (newValue && !this.form.claims.includes(License.createVehiclesNo)) {
          // Add
          this.form.claims.push(License.createVehiclesNo)
          this.form.claims.sort()
        } else if (!newValue && this.form.claims.includes(License.createVehiclesNo)) {
          // Remove
          this.form.claims = this.form.claims.filter(e => e !== License.createVehiclesNo)
        }
      }
    }
  },
  methods: {
    async submit () {
      this.preventLeave = false
      if (this.$refs.form.validate()) {
        this.submitting = true
        const res = await Admin.saveCorporation({
          Id: this.id,
          Name: this.form.name,
          FullName: this.form.fullName,
          Active: this.form.active,
          LicensedUsers: this.form.licensedUsers,
          Claims: this.form.claims.toString()
        })
        await this.saveLogo()
        this.submitting = false
        if (!res.failed) {
          this.$root.$message.showSuccess(this.$t('Saved'))
          this.$router.push({ name: this.redirectTo })
        }
      }
    },
    async loadLogo (corpId) {
      const detail = await CorporationDetail.load(corpId, 'Logo')
      if (process.env.NODE_ENV === 'development') console.log('--> Corporation logo detail: ', detail)

      const item = {
        ImageData: null,
        NameOfFile: ''
      }
      this.logoDetail = detail
      if (detail && detail.Data3 && detail.Data1) { // Data1 is NameOFFile, Data3 is imageData
        // Add a FileBytesAsBase64 that also contain the image type part
        // E.g.: from 'iVBORw0KGgoAAAANSU...' to 'data:image/png;base64,iVBORw0KGgoAAAANSU...'
        if (detail.Data1.toLowerCase().includes('jpg')) item.ImageData = 'data:image/jpg;base64,' + detail.Data3
        else item.ImageData = 'data:image/png;base64,' + detail.Data3
        item.NameOfFile = detail.Data1
      }
      this.logoImage = item
    },
    async changeLogo (logo) {
      let size = 0
      if (process.env.NODE_ENV === 'development') console.log('--> Corporation changing logo: ', logo)
      if (process.env.NODE_ENV === 'development') console.log('--> Corporation changing corporation detail: ', this.logoDetail)
      if (logo.ImageData != null && logo.ImageData !== undefined) {
        size = size + logo.ImageData.length
        // The 10% is for other payload data
        if (size * 1.1 >= 8 * 800 * 600) {
          app.$root.$message.showError(app.$t('Image is too large'))
          return false
        }
        // Add a FileBytesAsBase64 that also contain the image type part
        // E.g.: from 'iVBORw0KGgoAAAANSU...' to 'data:image/png;base64,iVBORw0KGgoAAAANSU...'
        // if (logo.NameOfFile.toLowerCase().includes('jpg')) {
        //   this.logoDetail.Data3 = 'data:image/jpg;base64,' + logo.FileBytesAsBase64
        // } else {
        //   this.logoDetail.Data3 = 'data:image/png;base64,' + logo.FileBytesAsBase64
        // }
        this.logoDetail.Data3 = logo.ImageData.substr(logo.ImageData.indexOf(',') + 1)
        this.logoDetail.Data1 = logo.NameOfFile
      } else {
        this.logoDetail.Data3 = null
        this.logoDetail.Data1 = null
      }
    },
    async saveLogo () {
      if (process.env.NODE_ENV === 'development') console.log('--> Corporation saving logo, detail: ', this.logoDetail)
      if (this.logoDetail) {
        return await this.logoDetail.save()
      }
    }
  },
  async mounted () {
    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })

    if (this.$route.params.id) {
      this.id = this.$route.params.id
      await this.loadLogo(this.id)
      const res = await Admin.loadCorporation(this.id)
      if (!res.failed && res.data) {
        this.form.name = res.data.Name
        this.form.fullName = res.data.FullName
        this.form.active = res.data.DeletedDate == null
        this.form.licensedUsers = res.data.LicensedUsers
        this.form.claims = res.data.Claims.split(',')
      }
    }
    this.$nextTick(() => {
      this.loading = false
    })
  }
}
</script>

<style>
.v-label theme--light {
    color: blue !important;
}
.small-label {
  float:left;
    /* font-size: 12px !important; */
    /* display:inline-block; */
  }
</style>
